import { createFileRoute } from "@tanstack/react-router";
import AdminDealers from "@/pages/AdminDealers";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/dealers/")({
  head: () => routeHead("/admin/dealers/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminDealers />
  );
}
